<template>
    <div v-if="dataLoad">
        <div>
            <div class="top">
                <div class="rate-menu">
                    <span @click="rateMenuShow=!rateMenuShow" :class="rateMenuShow ? 'unfold' : ''"><i>{{$t(currentRate)}}</i></span>
                    <ul @click="rateMenuShow=false" v-show="rateMenuShow">
                        <li :key="rate" v-for="rate in oddsRates" @click="currentRate=rate"
                            :class="currentRate=== rate ? 'sel' : ''">{{$t(rate)}}
                        </li>
                    </ul>
                </div>
                <nav>
                    <span id="erou" @click="currentTab='euro'" :class="currentTab=== 'euro' ? 'sel' : ''">{{ $t('odds_1x2') }}</span>
                    <span id="asia" @click="currentTab='asia'" :class="currentTab=== 'asia' ? 'sel' : ''">{{ $t('odds_handicap') }}</span>
                    <span id="ballsizer" @click="currentTab='over_under'"
                          :class="currentTab=== 'over_under' ? 'sel' : ''">{{ $t('odds_ou') }}</span>
                </nav>
            </div>

            <table id="erouList" class="list_4" v-if="currentTab === 'euro'">
                <thead>
                <tr>
                    <th>{{ $t('odds_company') }}</th>
                    <th>{{ $t('odds_type') }}</th>
                    <th>{{ $t('odds_home_win') }}</th>
                    <th>{{ $t('odds_draw') }}</th>
                    <th>{{ $t('odds_away_win') }}</th>
                    <th>{{ $t('odds_tu') }}</th>
                </tr>
                </thead>

                <tbody v-for="($euroCompany,index) in list['euro']" :key="index"
                       @click="gotoDetail($euroCompany['company']['id'], 'euro')">
                <tr>
                    <td rowspan="2" class="company">{{$euroCompany['company']['name']}}</td>
                    <td><span class="red">Spot</span></td>
                    <td>{{oddsFormat($euroCompany['odds']['last']['home'])}}</td>
                    <td>{{oddsFormat($euroCompany['odds']['last']['draw'])}}</td>
                    <td>{{oddsFormat($euroCompany['odds']['last']['away'])}}</td>
                    <td rowspan="2">{{$euroCompany['odds']['last']['timestamp'] | date}}</td>
                </tr>
                <tr>
                    <td>Initial</td>
                    <td>{{oddsFormat($euroCompany['odds']['first']['home'])}}</td>
                    <td>{{oddsFormat($euroCompany['odds']['first']['draw'])}}</td>
                    <td>{{oddsFormat($euroCompany['odds']['first']['away'])}}</td>
                </tr>
                </tbody>
            </table>
            <table id="asiaList" class="list_4" v-if="currentTab === 'asia'">
                <thead>
                <tr>
                    <th>{{ $t('odds_company') }}</th>
                    <th>{{ $t('odds_type') }}</th>
                    <th>{{ $t('odds_home_lose') }}</th>
                    <th>{{ $t('odds_hdp') }}</th>
                    <th>{{ $t('odds_away_lose') }}</th>
                    <th>{{ $t('odds_tu') }}</th>
                </tr>
                </thead>

                <tbody v-for="($asiaCompany, $index) in list['asia']" :key="$index"
                       @click="gotoDetail($asiaCompany['company']['id'], 'asia')">
                <tr>
                    <td rowspan="2" class="company">{{$asiaCompany['company']['name']}}</td>
                    <td><span class="red">Spot</span></td>
                    <td>{{oddsFormat($asiaCompany['odds']['last']['home'])}}</td>
                    <td>{{$asiaCompany['odds']['last']['draw']}}</td>
                    <td>{{oddsFormat($asiaCompany['odds']['last']['away'])}}</td>
                    <td rowspan="2">{{$asiaCompany['odds']['last']['timestamp'] | date}}</td>
                </tr>
                <tr>
                    <td>Initial</td>
                    <td>{{oddsFormat($asiaCompany['odds']['first']['home'])}}</td>
                    <td>{{$asiaCompany['odds']['first']['draw']}}</td>
                    <td>{{oddsFormat($asiaCompany['odds']['first']['away'])}}</td>
                </tr>
                </tbody>
            </table>
            <table id="ballsizerList" class="list_4" v-if="currentTab === 'over_under'">
                <thead>
                <tr>
                    <th>{{ $t('odds_company') }}</th>
                    <th>{{ $t('odds_type') }}</th>
                    <th>{{ $t('odds_over') }}</th>
                    <th>{{ $t('odds_total') }}</th>
                    <th>{{ $t('odds_under') }}</th>
                    <th>{{ $t('odds_tu') }}</th>
                </tr>
                </thead>

                <tbody v-for="($asiaCompany, $index) in list['over_under']" :key="$index"
                       @click="gotoDetail($asiaCompany['company']['id'], 'size')">
                <tr>
                    <td rowspan="2" class="company">{{$asiaCompany['company']['name']}}</td>
                    <td><span class="red">Spot</span></td>
                    <td>{{oddsFormat($asiaCompany['odds']['last']['home'])}}</td>
                    <td>{{$asiaCompany['odds']['last']['draw']}}</td>
                    <td>{{oddsFormat($asiaCompany['odds']['last']['away'])}}</td>
                    <td rowspan="2">{{$asiaCompany['odds']['last']['timestamp'] | date}}</td>
                </tr>
                <tr>
                    <td>Initial</td>
                    <td>{{oddsFormat($asiaCompany['odds']['first']['home'])}}</td>
                    <td>{{$asiaCompany['odds']['first']['draw']}}</td>
                    <td>{{oddsFormat($asiaCompany['odds']['first']['away'])}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="dataLoad && (!list[currentTab] || !list[currentTab].length)" class="no-data">{{ $t('odds_no_data') }}
        </div>
    </div>
</template>

<script>
    import dateFormat from 'dateformat';
    import Fraction from 'fraction.js';
    import messages from '../../lang/matchDetail';
    // import i18n from '@/util/i18n';
    import axios from 'axios';

    const URI_PREFIX = process.env.NODE_ENV === 'production' ? '/v2' : '';

    // 低版本客户端会调用本方法，sentry下会报错
    // window.setHeight = function () {
    //     console.log('setHeight');
    // };

    // window.videoIsPlaying = function () {
    //     return false;
    // };

    export default {
        // i18n,
        data () {
            return {
                currentTab: 'euro',
                dataLoad: false,
                currentRate: 'Decimal',
                rateMenuShow: false,
                oddsTabs: ['euro', 'asia', 'over_under'],
                oddsRates: ['Decimal', 'Fractional', 'American'],
                list: {
                    euro: [],
                    asia: [],
                    over_under: []
                }
            };
        },
        computed: {
            matchOddsFormation () {
                return this.$store.state.matchDetailStore.matchOddsFormation;
            }
        },
        created () {
            // this.oddsTabs.forEach(item => {
            //     // global.apiDomain = '//beta-n.allfootballapp.com';
            //     // axios.get(`${global.apiDomain}/api/data/odds_data/summary/${item}/${this.$route.query.id}`).then(response => {
            //     axios.get(`${global.apiDomain}/api/data/odds_data/summary/${item}/${this.$route.query.id}`).then(response => {
            //         // const res = response.data;
            //         // this.dataLoad = true;
            //         //
            //         // if (res.code) {
            //         //     // this.list[item] = res.data;
            //         //     this.$set(this.list, item, res.data);
            //         // }
            //     });
            // });
        },
        mounted () {
            if (window.localStorage && window.localStorage.currentRate) {
                this.currentRate = localStorage.currentRate;
            }
            if (!this.$route.params.id) {
                this.dataLoad = true;
                return;
            }
            this.dataLoad = true;
            this.$set(this.list, 'euro', this.matchOddsFormation.euro.data || []);
            this.$set(this.list, 'asia', this.matchOddsFormation.asia.data || []);
            this.$set(this.list, 'over_under', this.matchOddsFormation.overUnder.data || []);
        },
        watch: {
            currentRate () {
                if (window.localStorage) {
                    localStorage.currentRate = this.currentRate;
                }
            }
        },
        methods: {
            oddsFormat (odds) {
                if (this.currentTab !== 'euro') {
                    return odds;
                }
                if (/^\d+(\.\d+)?$/.test(odds.toString())) {
                    if (this.currentRate === 'American') {
                        if (odds >= 2) {
                            return Math.floor((odds - 1) * 100);
                        } else {
                            return Math.floor(100 / (1 - odds));
                        }
                    }

                    if (this.currentRate === 'Fractional') {
                        return new Fraction(odds).toFraction();
                    }
                }

                return odds;
            },

            gotoDetail (id, type) {
                let m = parseInt(this.$route.query.id);
                if (m <= 50000000) {
                    m += 50000000; // 新老接口比赛id不统一，需加一个5kw做兼容
                }
                this.$router.push('/matchOdds?matchId=50956312&companyId=1183&type=euro&rate=Decimal&language=en-US');
                // location.href = `http://n.allfootballapp.com/v2/${URI_PREFIX}/oddsChanges?matchId=${m}&companyId=${id}&type=${type}&rate=${this.currentRate}&language=${i18n.locale || 'en'}`;
            }
        },
        filters: {
            date (str) {
                return dateFormat(str.replace(/-/g, '/'), 'dd mmm, HH:MM'); // 字符串截取
            }
        }
    };
</script>
<style scoped lang="less">
    a {
        color: #000;
    }

    html,
    body {
        height: 100%;
    }

    body {
        margin: 0;
        padding: 0;
        width: 100%;
        background: #eff1f4;
        font-size: 12px;
        /*-webkit-font-smoothing: antialiased;*/
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        position: relative;
    }

    .no-data {
        font-size: 12px;
        text-align: center;
        color: #babdc2;
        line-height: 23px;
        padding-top: 42%;
        background: #fff !important;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
    }

    .top {
        padding: 1em;
        height: 27px;
        position: relative;
        z-index: 2;
    }

    nav {
        height: 25px;
        line-height: 25px;
        text-align: center;
        float: left;
        color: #16ac3a;
        border: 1px solid #16ac3a;
        /*no*/
        border-radius: 2px;
        float: left;
        width: 72%;
        margin: 1em;
        font-size: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 0;
    }

    nav span {
        display: inline-block;
        text-align: center;
        width: 33.3%;
        font-size: 12px;
        border-left: 1px solid #16ac3a;
        /*no*/
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    nav span:first-child {
        border: none;
    }

    nav span.sel {
        color: #fff;
        background: #16ac3a;
    }

    div.rate-menu {
        float: right;
        line-height: 27px;
        position: relative;
        max-width: 25%;
        white-space: nowrap;
    }

    div.rate-menu span {
        display: block;
        text-align: right;
    }

    div.rate-menu span i {
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 85%;
        float: left;
    }

    div.rate-menu span:after {
        content: '';
        display: inline-block;
        height: 12px;
        width: 24px;
        background: url(./assets/arrow.png) no-repeat;
        background-size: 50%;
        background-position: center;
        transform: rotateZ(180deg);
        vertical-align: -2px;
        transition: transform 0.15s linear;
    }

    div.rate-menu span.unfold:after {
        vertical-align: -1px;
        transform: none;
    }

    div.rate-menu ul {
        position: absolute;
        top: 27px;
        list-style: none;
        border: 1px solid #eee;
        /*no*/
        z-index: 2;
        background: #fff;
        right: 0;
        text-align: center;
        padding: 0;
        margin: 0;
        min-width: 200px;
    }

    div.rate-menu li {
        display: block;
        line-height: 45px;
        border-bottom: 1px solid #eee;
        /*no*/
        overflow: hidden;
        padding: 0 10px;
        text-overflow: ellipsis;
    }

    div.rate-menu li.sel {
        color: #16ac3a;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    .list_4 {
        border-spacing: 0;
    }

    .list_4 th {
        text-align: center;
        transform: scale(1);
        color: #333;
        background: #eefcf1;
        border: 1px solid #ddd;
        /*no*/
        margin: 0;
        padding: 0;
        height: 24px;
        line-height: 24px;
        word-break: break-word;
    }

    .list_4 td {
        background: #fff;
        height: 28px;
        line-height: 28px;
        text-align: center;
    }

    .list_4 tr th:nth-child(1) {
        font-weight: 700;
    }

    .list_4 tr th:nth-child(1) {
        width: 80px;
    }

    .list_4 tr th:nth-child(2) {
        width: 60px;
    }

    .list_4 tr th:nth-child(3) {
        width: 50px;
    }

    .list_4 tr th:nth-child(4) {
        width: 50px;
    }

    .list_4 tr th:nth-child(5) {
        width: 50px;
    }

    .list_4 tr th:nth-child(6) {
        width: 80px;
    }

    .list_4 tbody:nth-child(odd) td {
        background: #eefcf1;
    }

    .list_4 tbody {
        border-top: 1px solid #ddd;
    }

    .red {
        color: #e52000;
    }
</style>




// WEBPACK FOOTER //
// App.vue?562f4907